export * from '@sportworld/js-sdk/src/constants/analytics'

export const milestoneSecInterval = 10 //sec
export const milestonePercentPoints = [5, 15, 25, 40, 50, 60, 75, 90, 100]

export const analyticsPageTypes = {
  HOME: 'home',
  HOME_TAB: 'home-tab',
  CONTENT_HUB: 'content-hub', // tab template
  EPG_DETAILS: 'epg-details', // details page
  CATEGORY: 'category', // sports-category page
  CALENDAR: 'calendar',
  SETTINGS: 'settings',
  OVERVIEW: 'overview', // page (not category) + Specials Page
  FAVORITES: 'favorites',
  FEATURE_SCREEN: 'feature-screen',
  OTHER: 'other',
}

export const analyticsFavoriteTypes = {
  CONTENT_HUB: 'content-hub',
  SPORT: 'sport',
}

export enum analyticsVideoTypes {
  VOD = 'vod',
  STREAM = 'stream',
  TUNING = 'tuning',
}

export enum videoPlayerNames {
  NW = 'native-waves',
  HLS = 'hls',
  YOUTUBE = 'youtube',
}

export enum platformIds {
  CTV_SAMSUNG = 'sportworld-ctv-samsung',
  CTV_LG = 'sportworld-ctv-lg',
}

export const pageNamesWithPostfix = {
  selected: 'selected-home',
  favorites: 'favorites-home',
  settings: 'settings-home',
  sports: 'sports-home',
}

export const appOpenedSource = {
  /** APP_OPENED */
  NORMAL: 'normal',
  SMART_HUB: 'smart-hub',
  DEEP_LINK: 'deep-link',
  UNIVERSAL_GUIDE: 'universal-guide',
}

/**gtag analytics **/

export const pageTitle = {
  '/home': 'Home', // use data.page.name
  '/sports': 'Sports', // use data.page.name
  '/calendar': 'Calendar', // use data.page.name
  '/settings/subscriptions': 'Settings: Subscriptions',
  '/settings/offers': 'Settings: Offers',
  '/settings/account': 'Settings: Account',
  '/settings/imprint': 'Settings: Imprint',
  '/settings/data-privacy': 'Settings: Data Privacy',
  '/settings/analytics-cookie': 'Settings: AGBs',
  '/settings/developer': 'Developer',
  '/event': 'Detail page',
  '/page': 'Page', // use data.page.name
  '/selected': 'Selected', // use data.page.name
  '/media/player': 'Media player',
  '/login': 'Login',
  '/register': 'Register',
  '/checkout': 'Checkout',
  '/selfService': 'Self service',
  '/welcome': 'Welcome',
  '/logout': 'Logout',
  '/exit': 'Exit',
  '/favorites': 'Favorites',
  '/list': 'View more',
  '/settings/region': 'Settings: Region',
}
